<!-- <div class="tileHeading">{{title}}</div> -->
<table class="table-container">
    <tr>
        <th colspan="2" class="text">Party</th>
        <th class="num">{{thisYear}}</th>
        <th *ngIf="hasPrev == true" class="num">{{prevYear}}</th>
        <th *ngIf="hasPrev == true" class="num">change</th>
    </tr>
    <tr *ngFor="let seatsWon of seatsWons">
        <td [ngStyle]="{'background-color':seatsWon.colourCode}" class="color-code">&nbsp;</td>
        <td>{{seatsWon.party}}</td>
        <td class="num">{{seatsWon.seatsThisElection}}</td>
        <td *ngIf="hasPrev == true" class="num">{{seatsWon.seatsPreviousElection}}</td>
        <td *ngIf="hasPrev == true" class="num">{{seatsWon.change}}</td>
    </tr>
</table>